import { Component, ChangeDetectorRef, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { filter, Subject, Subscription, takeUntil, combineLatest, distinctUntilChanged, switchMap, tap } from 'rxjs';
import { DataService } from '../../services/data';
import { MessageModule } from 'primeng/message';
import { FirestoreService } from '../../services/firestore';
import { PreInformeDoc } from '../../models/preinforme.model';
import { TagModule } from 'primeng/tag';
import { Member } from '../../models/member.model';
import { Iglesia } from '../../models/iglesia.model';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { Informes, InformeMensualPdfPayload, InformeItemBasePayload } from '../../models/informes.model';
import { getBytes, getStorage, ref } from 'firebase/storage';
import { Funciones } from '../../services/funciones';
import { httpsCallable, getFunctions } from 'firebase/functions';
import { ToastModule } from 'primeng/toast';
import { ToastService } from '../../services/toast.service';
import { SpinnerService } from '../../services/spinner.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';
import { CuentaBancaria } from '../../models/financial-config.model';
import { LanguageService } from '../../services/language.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MissionCurrencyService } from '../../services/mission-currency.service';
import { MissionMoneyPipe } from '../../pipes/mission-money.pipe';

interface InformeMensualPdfResponse {
  base64?: string;
  contentType?: string;
  fileName?: string;
}

@Component({
  selector: 'app-reports',
  imports: [ReactiveFormsModule, CommonModule, InputNumberModule, FormsModule, InputTextModule, RadioButtonModule, TableModule, ToggleButtonModule, MessageModule, TagModule, ButtonModule, ConfirmDialogModule, TextareaModule, SelectModule, DialogModule, TranslateModule, MissionMoneyPipe],
  templateUrl: './reports.html',
  styleUrl: './reports.css',
  encapsulation: ViewEncapsulation.None,
})
export class Reports implements OnInit, OnDestroy {
  //SUBSCRIPTIONES
  private subscriptions = new Subscription();

  dataPreInforme: PreInformeDoc | null = null;
  members: Member[] = [];
  iglesiaData: Iglesia | null = null;

  loading: boolean = false;
  loadingPdf: boolean = false;

  finanzas: any[] = [];
  iglesia: string = '';
  mesAno: string = '';
  movimientosExtraParaCerrar: any[] = [];

  //DATA A LLENAR
  diezmoIglesia: number = 0;
  ofrendasDiarias: number = 0
  diezmoDeDiezmo: number = 0;

  churchId: string = '';

  // INFORME ESPIRITUAL (codigos IE-xx alineados con pre-informe / Settings i18n)
  informeEspiritualOptions: Informes[] = [
    { item: 1, codigo: 'IE-01', descripcion: 'Miembros bautizados activos', valor: 0 },
    { item: 2, codigo: 'IE-02', descripcion: 'Creyentes bautizados no reconocidos', valor: 0 },
    { item: 3, codigo: 'IE-03', descripcion: 'Nuevos creyentes', valor: 0 },
    { item: 4, codigo: 'IE-04', descripcion: 'Miembros bautizados en Espíritu Santo', valor: 0 },
    { item: 5, codigo: 'IE-05', descripcion: 'Profesiones de fe durante el mes', valor: 0 },
    { item: 6, codigo: 'IE-06', descripcion: 'Promedio asistencia Escuela Dominical', valor: 0 }
  ];

  // INFORME OBRERO
  informeObreoOptions: Informes[] = [
    { item: 1, codigo: 'OB-01', descripcion: 'Efectuó culto misionero', valor: '' },
    { item: 2, codigo: 'OB-02', descripcion: 'Efectuó culto Santa Cena', valor: '' },
    { item: 3, codigo: 'OB-03', descripcion: 'Asistió a culto confraternidad', valor: '' },
    { item: 4, codigo: 'OB-04', descripcion: 'Recibió visita del presbítero', valor: '' },
    { item: 5, codigo: 'OB-05', descripcion: 'Efectuó visitas', valor: '' },
    { item: 6, codigo: 'OB-06', descripcion: 'Realizó evangelismo', valor: '' },
    { item: 7, codigo: 'OB-07', descripcion: 'Ha fundado campos blancos', valor: '' },
    { item: 8, codigo: 'OB-08', descripcion: 'Ha formado obreros', valor: '' },
    { item: 9, codigo: 'OB-09', descripcion: 'Efectúa ayuda social', valor: '' },
    { item: 10, codigo: 'OB-10', descripcion: 'Efectuó ayuno', valor: '' }
  ];

  // INGRESOS
  informeFinancieroIngresosOptions: Informes[] = [
    { item: 1, codigo: 'ING-01', descripcion: 'Diezmo iglesia', valor: this.diezmoDeDiezmo },
    { item: 2, codigo: 'ING-02', descripcion: 'Ofrendas diarias', valor: 0 },
    { item: 3, codigo: 'ING-03', descripcion: 'Ofrendas Escuela Dominical', valor: 0 },
    { item: '', codigo: 'ING-SUB', descripcion: 'SUB TOTAL', valor: 0 },
    { item: 4, codigo: 'ING-04', descripcion: 'Ofrendas (Programa Radial)', valor: 0 },
    { item: 5, codigo: 'ING-05', descripcion: 'Ofrenda Misionera', valor: 0 },
    { item: 6, codigo: 'ING-06', descripcion: 'Ofrenda Predicador', valor: 0 },
    { item: 7, codigo: 'ING-07', descripcion: 'Ofrenda Especial', valor: 0 },
    { item: 8, codigo: 'ING-08', descripcion: 'Ayuda Fondo Nacional/Internacional', valor: 0 },
    { item: '', codigo: 'ING-TOTAL', descripcion: 'TOTAL INGRESO GENERAL IGLESÍA', valor: 0 }
  ];

  // EGRESOS B.1
  informeFinancieroEgresosB1Options: Informes[] = [
    { item: 1, codigo: 'EG-B1-01', descripcion: 'Alquiler local Iglesia', valor: 0 },
    { item: 2, codigo: 'EG-B1-02', descripcion: 'Pago de luz, agua, gas, teléfono (Iglesia)', valor: 0 },
    { item: 3, codigo: 'EG-B1-03', descripcion: 'Pago de impuesto', valor: 0 },
    { item: 4, codigo: 'EG-B1-04', descripcion: 'Mantenimiento y mejoras del templo', valor: 0 },
    { item: 5, codigo: 'EG-B1-05', descripcion: 'Gastos de oficina, copias, envíos documentos', valor: 0 },
    { item: 6, codigo: 'EG-B1-06', descripcion: 'Compra de mob, equipos, instrumentos', valor: 0 },
    { item: 7, codigo: 'EG-B1-07', descripcion: 'Seguridad social', valor: 0 },
    { item: 8, codigo: 'EG-B1-08', descripcion: 'Alquiler casa pastoral', valor: 0 },
    { item: 9, codigo: 'EG-B1-09', descripcion: 'Pago luz, agua, gas (Casa Pastoral)', valor: 0 },
    { item: 10, codigo: 'EG-B1-10', descripcion: 'Transportes, viáticos', valor: 0 },
    { item: 11, codigo: 'EG-B1-11', descripcion: 'Pago préstamos', valor: 0 },
    { item: 12, codigo: 'EG-B1-12', descripcion: 'Programa radial', valor: 0 },
    { item: 13, codigo: 'EG-B1-13', descripcion: 'Sostén del pastor', valor: 0 },
    { item: 14, codigo: 'EG-B1-14', descripcion: 'Otros (Ayudas, comidas, Escuela Dominical)', valor: 0 },
    { item: 15, codigo: 'EG-B1-15', descripcion: 'Ofrenda al predicador', valor: 0 },
    { item: 16, codigo: 'EG-B1-16', descripcion: 'Impuesto vehículo', valor: 0 },
    { item: 17, codigo: 'EG-B1-17', descripcion: 'Mantenimiento del vehículo', valor: 0 },
    { item: 18, codigo: 'EG-B1-18', descripcion: 'Parking', valor: 0 },
    { item: '', codigo: 'EG-B1-SUB', descripcion: 'SUB-TOTAL (B.1)', valor: 0 }
  ];

  // EGRESOS B.2
  informeFinancieroEgresosB2Options: Informes[] = [
    { item: 1, codigo: 'EG-B2-01', descripcion: 'Diezmos de diezmos y ofrendas', valor: 0 },
    { item: 2, codigo: 'EG-B2-02', descripcion: 'Ofrenda Misionera', valor: 0 },
    { item: 3, codigo: 'EG-B2-03', descripcion: 'Ofrenda Pro-convención', valor: 0 },
    //{ item: 4, codigo: 'EG-B2-04', descripcion: 'Ofrenda confraternidad', valor: 0 },
    { item: 5, codigo: 'EG-B2-05', descripcion: 'Cuota FEREDE', valor: 0 },
    { item: 6, codigo: 'EG-B2-06', descripcion: 'Gestor', valor: 0 },
    //{ item: 7, codigo: 'EG-B2-07', descripcion: 'Servidor MMM', valor: 0 },
    { item: 8, codigo: 'EG-B2-08', descripcion: 'Otras ofrendas y pagos', valor: 0 },
    //{ item: 9, codigo: 'EG-B2-09', descripcion: 'Seguridad Social', valor: 0 },
    { item: 10, codigo: 'EG-B2-10', descripcion: 'Seguro de Vida', valor: 0 },
    { item: 11, codigo: 'EG-B2-11', descripcion: 'Seguro defunción', valor: 0 },
    { item: 12, codigo: 'EG-B2-12', descripcion: 'I.R.P.F.', valor: 0 },
    { item: 13, codigo: 'EG-B2-13', descripcion: 'Pago Sistema Informe', valor: 5 },
    { item: 14, codigo: 'EG-B2-14', descripcion: 'Bethel TV España', valor: 0 },
    { item: 15, codigo: 'EG-B2-15', descripcion: 'Pago Préstamo', valor: 0 },
    { item: 16, codigo: 'EG-B2-16', descripcion: 'Ofrenda Valdepeñas', valor: 0 },
    { item: '', codigo: 'EG-B2-SUB', descripcion: 'SUB-TOTAL B.2', valor: 0 },
    { item: '*', codigo: 'EG-B2-DP', descripcion: 'Diezmos del pastor', valor: 0 },
    { item: '', codigo: 'EG-B2-TOTAL', descripcion: 'TOTAL ENVIADO FONDO NACIONAL', valor: 0 }
  ];

  // BALANCE
  informeFinancieroBalanceOptions: Informes[] = [
    { item: '', codigo: 'BAL-ING-TOT', descripcion: 'Total General de Ingresos', valor: 0 },
    { item: '', codigo: 'BAL-EGR-TOT', descripcion: 'Total General de Egresos (B.1 + B.2)', valor: 0 },
    { item: '', codigo: 'BAL-SAL-MES', descripcion: 'Saldo en Caja del Mes', valor: 0 },
    { item: '', codigo: 'BAL-SAL-ANT', descripcion: 'Saldo en Caja Mes Anterior', valor: 0 },
    { item: '', codigo: 'BAL-FINAL', descripcion: 'SALDO FINAL DEL MES', valor: 0 }
  ];

  // OBSERVACIONES
  observacionesOptions: Informes[] = [
    { item: '', codigo: 'OBS-ENUN', descripcion: 'EN LA CASILLA "OTRAS OFRENDAS Y PAGOS" SE REFLEJAN LOS PAGOS DE:', valor: '' },
    { item: '', codigo: 'OBS-01', descripcion: 'Seguro Defunción', valor: 0 },
    { item: '', codigo: 'OBS-02', descripcion: 'Seguro Vida Pastor', valor: 0 },
    { item: '', codigo: 'OBS-03', descripcion: 'Ayuda Local Valdepeñas', valor: 0 }
  ];

  observaciones: string = '';
  pastor: string = '';
  // Para la firma, puedes agregar una variable como esta si necesitas manejar una imagen o datos de firma:
  // firmaPastor: string = ''; // e.g., base64 image or URL

  // GESTIÓN DE BANCOS (cuenta origen para egresos B.2 al cerrar informe)
  manejarBancos: boolean = false;
  cuentasBancarias: CuentaBancaria[] = [];
  cuentaOrigenCierre: string = 'caja-menor';
  showCierreDialog: boolean = false;
  private openPeriodoData: any = null; // objeto Periodo completo para detectar re-cierres

  //BANNER
  showBanner: boolean = false;
  movementsBlocked = false;
  openPeriodsDisplay = '';
  previousMonthName: string = '';
  periodo: string = '';

  informeYM: string = '';
  currYM: string = '';
  prevYM: string = '';
  iglesiaName: string = '';
  pastorName: string = '';

  imageFirmaUrl: string | null = null;
  signatureImageError = false;
  isExporting = false;

  private destroy$ = new Subject<void>();


  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private firestoreService: FirestoreService,
    private router: Router,
    private funciones: Funciones,
    private toastService: ToastService,
    private spinnerService: SpinnerService,
    private confirmationService: ConfirmationService,
    public languageService: LanguageService,
    private translate: TranslateService,
    private readonly missionCurrency: MissionCurrencyService,
  ) {
  }

  ngOnInit() {
    // Check Permissions
    this.subscriptions.add(
      this.dataService.userRoles$.subscribe(roles => {
        const allowedRoles = ['Admin', 'Pastor', 'Tesorería', 'access_finanzas'];
        const hasAccess = roles.some(role => allowedRoles.includes(role));
        if (!hasAccess) {
          this.router.navigate(['/dashboard/main']);
        }
      })
    );

    this.subscriptions.add(
      this.translate.onLangChange.subscribe(() => this.cdr.detectChanges())
    );

    this.suscripciones();
  }

  /** Etiqueta de fila de informe: Firestore i18nItems por código, filas financieras fijas (REPORTS.ROW_*), fallback IT estático. */
  getInformeLabel(codigo: string | undefined, descripcion: string): string {
    const es = descripcion ?? '';
    if (this.languageService.getCurrentLang() !== 'it') return es;
    const fromDict = this.languageService.getItemLabel(codigo, es);
    if (fromDict !== es) return fromDict;
    const rowKey = this.financialTotalsRowKey(codigo);
    if (rowKey) return this.translate.instant(rowKey);
    return this.translateStaticInformeLabelIt(es);
  }

  /** Filas de subtotal/total/balance con texto ES fijo; traducción IT por código estable. */
  private financialTotalsRowKey(codigo: string | undefined): string | null {
    const keys: Record<string, string> = {
      'ING-SUB': 'REPORTS.ROW_ING_SUB',
      'ING-TOTAL': 'REPORTS.ROW_ING_TOTAL',
      'EG-B1-SUB': 'REPORTS.ROW_EG_B1_SUB',
      'EG-B2-SUB': 'REPORTS.ROW_EG_B2_SUB',
      'EG-B2-TOTAL': 'REPORTS.ROW_EG_B2_TOTAL',
      'BAL-ING-TOT': 'REPORTS.ROW_BAL_ING_TOT',
      'BAL-EGR-TOT': 'REPORTS.ROW_BAL_EGR_TOT',
      'BAL-SAL-MES': 'REPORTS.ROW_BAL_SAL_MES',
      'BAL-SAL-ANT': 'REPORTS.ROW_BAL_SAL_ANT',
      'BAL-FINAL': 'REPORTS.ROW_BAL_FINAL',
    };
    const c = String(codigo ?? '').trim();
    return keys[c] ?? null;
  }

  obreroTagLabel(affirmative: boolean): string {
    return affirmative
      ? this.translate.instant('REPORTS.OBRERO_TAG_YES')
      : this.translate.instant('REPORTS.OBRERO_TAG_NO');
  }

  get hasSignatureImage(): boolean {
    return !!this.normalizeSignatureUrl(this.imageFirmaUrl) && !this.signatureImageError;
  }

  handleSignatureImageError(): void {
    this.signatureImageError = true;
    this.cdr.markForCheck();
  }

  private normalizeSignatureUrl(value: unknown): string | null {
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }

  private setSignatureUrl(value: unknown): void {
    this.imageFirmaUrl = this.normalizeSignatureUrl(value);
    this.signatureImageError = false;
  }

  private suscripciones() {

    this.subscriptions.add(
      this.dataService.churchId$.subscribe(churchId => {
        this.churchId = churchId!!;
      })
    );

    this.dataService.members$.subscribe(mems => {
      this.members = mems || [];
    });

    this.subscriptions.add(
      this.dataService.periodosFinancierosState$.subscribe(state => {
        this.movementsBlocked = state.movementsBlocked;
        this.openPeriodsDisplay = state.openYms
          .map(ym => this.funciones.formatYMtoText(ym))
          .join(', ');
      })
    );

    // Una sola cadena activa: si se apilan combineLatest (banner false→true o
    // re-emisiones de periodos), offerings$ del mes actual pisa los montos del
    // período a cerrar (offeringsPrevMonth$) y el informe queda en ceros.
    this.subscriptions.add(
      this.dataService.banner$.pipe(
        distinctUntilChanged(),
        tap(show => {
          this.showBanner = show;
          if (show) {
            this.mesInformeYM();
          } else {
            const fechActual = new Date();
            const month = fechActual.getMonth();
            const year = fechActual.getFullYear();
            const periodoActual = `${year}-${(month + 1).toString().padStart(2, '0')}`;
            this.informeYM = this.funciones.formatYMtoText(periodoActual);
            this.mesAno = this.informeYM;
          }
        }),
        switchMap(show => {
          // preInforme$ va en el combineLatest para que llenarDesdeDoc corra
          // ANTES de aplicarConfiguracionDinamica en el mismo ciclo.
          const offerings$ = show
            ? this.dataService.offeringsPrevMonth$.pipe(filter(ofs => Array.isArray(ofs)))
            : this.dataService.offerings$.pipe(filter(ofs => Array.isArray(ofs)));
          return combineLatest([
            this.dataService.preInforme$,
            offerings$,
            this.dataService.informeConfig$,
          ]);
        })
      ).subscribe(([preInforme, offerings, config]) => {
        this.logPreInformeDebug(this.showBanner ? 'prev-banner' : 'current', preInforme);
        this.llenarDesdeDoc(preInforme);
        this.aplicarConfiguracionDinamica(config);
        this.finanzas = offerings;
        this.calcularInformeFinanciero();
      })
    );

    this.subscriptions.add(
      this.dataService.openPeriodo$.subscribe(periodo => {
        const ym = periodo?.id || '';
        const name = this.funciones.formatYMtoText(ym);
        this.previousMonthName = name;
        this.periodo = ym;
        this.openPeriodoData = periodo; // guardar para detectar re-cierres
      })
    );

    this.subscriptions.add(
      this.dataService.dataChurch$.subscribe(data => {
        this.iglesiaData = data;
        this.iglesiaName = data?.churchName || '';
        this.pastorName = data?.pastorName || '';
      })
    );

    this.subscriptions.add(
      this.dataService.churchSignatureUrl$.subscribe(url => {
        this.setSignatureUrl(url);
      })
    );

    this.subscriptions.add(
      this.dataService.manejarBancos$.subscribe(value => {
        this.manejarBancos = value;
      })
    );

    this.subscriptions.add(
      this.dataService.cuentasBancarias$.subscribe(cuentas => {
        this.cuentasBancarias = cuentas;
        if (cuentas.length > 0) {
          const def = cuentas.find(c => c.esDefault && c.activo) || cuentas.find(c => c.activo);
          this.cuentaOrigenCierre = def?.id || 'caja-menor';
        }
      })
    );

  }

  private aplicarConfiguracionDinamica(configDinamico: any) {
    if (!configDinamico) return; // Si es null, usa los defaults estáticos

    const protegidos = [
      'ING-SUB',
      'ING-TOTAL',
      'EG-B1-SUB',
      'EG-B2-SUB',
      'EG-B2-DP',
      'EG-B2-TOTAL',
      'BAL-ING-TOT',
      'BAL-EGR-TOT',
      'BAL-SAL-MES',
      'BAL-SAL-ANT',
      'BAL-FINAL'
    ];

    // Mapeo dinámico fusionando los defaults locales (por seguridad/orden base)
    // con los overrides/adiciones de Firestore.

    // Asumimos que Firestore trae las colecciones por su nombre de clave: 'obrero', 'ingresos', 'egresosB1', 'egresosB2'
    if (configDinamico.obrero) {
      this.informeObreoOptions = this.dataService.fusionarOpcionesInformes(this.informeObreoOptions, configDinamico.obrero, protegidos);
    }
    if (configDinamico.ingresos) {
      this.informeFinancieroIngresosOptions = this.dataService.fusionarOpcionesInformes(this.informeFinancieroIngresosOptions, configDinamico.ingresos, protegidos);
      this.reordenarIngresosSubTotal();
    }
    if (configDinamico.egresosB1) {
      this.informeFinancieroEgresosB1Options = this.dataService.fusionarOpcionesInformes(this.informeFinancieroEgresosB1Options, configDinamico.egresosB1, protegidos);
    }
    if (configDinamico.egresosB2) {
      this.informeFinancieroEgresosB2Options = this.dataService.fusionarOpcionesInformes(this.informeFinancieroEgresosB2Options, configDinamico.egresosB2, protegidos);
      this.reordenarEgresosB2SubTotal();
    }

    this.cdr.markForCheck();
  }

  private reordenarEgresosB2SubTotal(): void {
    const list = this.informeFinancieroEgresosB2Options || [];
    const subIndex = list.findIndex(r => r.codigo === 'EG-B2-SUB');
    const dpIndex = list.findIndex(r => r.codigo === 'EG-B2-DP');
    if (subIndex === -1 || dpIndex === -1) return;
    if (subIndex < dpIndex) return;
    const [subRow] = list.splice(subIndex, 1);
    const newDpIndex = list.findIndex(r => r.codigo === 'EG-B2-DP');
    const insertAt = newDpIndex === -1 ? list.length : newDpIndex;
    list.splice(insertAt, 0, subRow);
    this.informeFinancieroEgresosB2Options = list;
  }

  private reordenarIngresosSubTotal(): void {
    const list = this.informeFinancieroIngresosOptions || [];
    const subIndex = list.findIndex(r => r.codigo === 'ING-SUB');
    if (subIndex === -1) return;
    const targetIndex = list.findIndex(r => r.codigo === 'ING-03');
    if (targetIndex === -1) return;
    const [subRow] = list.splice(subIndex, 1);
    list.splice(targetIndex + 1, 0, subRow);
    this.informeFinancieroIngresosOptions = list;
  }

  private buildInformeData(firmaBase64?: string | null): any {
    const mapRows = (arr: Informes[] = []) =>
      (arr || []).map(r => ({
        item: r.item,
        codigo: r.codigo ?? null,
        descripcion: r.descripcion ?? null,
        valor: typeof r.valor !== 'undefined' ? r.valor : null,
      }));

    return {
      meta: {
        generatedAt: new Date().toISOString(),
        uiSnapshotVersion: 1,
        churchId: this.churchId,
        periodoYm: this.periodo || this.prevYM
      },
      header: {
        iglesiaName: this.iglesiaName,
        pastorName: this.pastorName,
        // Siempre alinear con this.periodo (mismo YM que el cierre / id documento);
        // mesAno/informeYM pueden reflejar el mes calendario actual cuando showBanner es false.
        periodoDisplay: this.periodo
          ? this.funciones.formatYMtoText(this.periodo)
          : (this.previousMonthName || this.mesAno || this.informeYM)
      },
      espiritual: mapRows(this.informeEspiritualOptions),
      obrero: mapRows(this.informeObreoOptions),
      financiero: {
        ingresos: mapRows(this.informeFinancieroIngresosOptions),
        egresosB1: mapRows(this.informeFinancieroEgresosB1Options),
        egresosB2: mapRows(this.informeFinancieroEgresosB2Options),
        balance: mapRows(this.informeFinancieroBalanceOptions)
      },
      observaciones: this.observaciones,
      firma: {
        url: this.imageFirmaUrl ?? null,
        base64: firmaBase64 ?? null  // ← Guardar base64 para preservar firma histórica
      },
      // Snapshot de configuración de items para preservar estructura histórica
      itemsSnapshot: {
        espiritual: [...this.informeEspiritualOptions],
        obrero: [...this.informeObreoOptions],
        financiero: {
          ingresos: [...this.informeFinancieroIngresosOptions],
          egresosB1: [...this.informeFinancieroEgresosB1Options],
          egresosB2: [...this.informeFinancieroEgresosB2Options],
          balance: [...this.informeFinancieroBalanceOptions]
        },
        observaciones: [...this.observacionesOptions]
      }
    };
  }

  async cerrarInforme(): Promise<void> {
    if (!this.churchId) return;
    const ym = this.periodo || '';
    if (!ym) {
      return;
    }

    this.spinnerService.show();

    // Convertir la firma a base64 para preservar la firma del momento del cierre
    const firmaBase64 = await this.urlToBase64(this.imageFirmaUrl);
    const informeData = this.buildInformeData(firmaBase64);
    const movimientosExtra = Array.isArray(this.movimientosExtraParaCerrar) ? this.movimientosExtraParaCerrar : [];

    try {
      const functions = getFunctions();
      const cerrarCallable = httpsCallable(functions, 'cerrarInformeMensual');
      const res = await cerrarCallable({
        churchId: this.churchId,
        ym,
        informeData,
        movimientosExtra,
        manejarBancos: this.manejarBancos,
        cuentaOrigenCierre: this.cuentaOrigenCierre
      });
      const data = (res && (res as any).data) ? (res as any).data : res;

      if (data?.success) {
        // refrescar periodo abierto más viejo y propagar
        this.firestoreService.getOldestOpenPeriodo(this.churchId)
          .pipe(takeUntil(this.destroy$))
          .subscribe(periodo => {
            this.dataService.updateOpenPeriodo(periodo);
          });
        this.toastService.showSuccess(this.translate.instant('REPORTS.TOAST_CLOSE_OK', { ym }));
        // Advertir si algún saldo quedó negativo tras la deducción
        if (data.saldoNegativoWarning) {
          const w = data.saldoNegativoWarning;
          this.toastService.showWarning(
            this.translate.instant('REPORTS.TOAST_WARN_NEGATIVE_BALANCE', {
              cuentaId: w.cuentaId,
              monto: Number(w.montoDeducido).toFixed(2),
              saldo: Number(w.saldoActual).toFixed(2),
            })
          );
        }
      } else {
        this.toastService.showError(this.translate.instant('REPORTS.TOAST_CLOSE_ERR'));
      }
    } catch (err: any) {
      this.toastService.showError(
        this.translate.instant('REPORTS.TOAST_CLOSE_ERR_DETAIL', { detail: err?.message || err.toString() })
      );
    } finally {
      this.spinnerService.hide();
    }
  }

  async confirmarCerrarMovimiento(): Promise<void> {
    // Prevent closing current month report
    const now = new Date();
    const currentMonthId = now.toISOString().slice(0, 7); // YYYY-MM

    if (this.periodo === currentMonthId) {
      this.toastService.showWarning(this.translate.instant('REPORTS.TOAST_WARN_CURRENT_MONTH'));
      return;
    }

    // VALIDATION: Prevent closing if Balance Final is negative
    // Redondear a 2 decimales para no bloquear por errores de punto flotante (ej: -0.000000001 → 0.00)
    const saldoFinalRow = this.informeFinancieroBalanceOptions.find(r => r.codigo === 'BAL-FINAL');
    const saldoFinal = Math.round((saldoFinalRow ? Number(saldoFinalRow.valor) : 0) * 100) / 100;

    if (saldoFinal < 0) {
      this.confirmationService.confirm({
        message: this.translate.instant('REPORTS.CONFIRM_NEGATIVE_BALANCE_MSG'),
        header: this.translate.instant('REPORTS.CONFIRM_NEGATIVE_BALANCE_HEADER'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.translate.instant('REPORTS.CONFIRM_NEGATIVE_BALANCE_OK'),
        rejectVisible: false,
        acceptButtonStyleClass: 'p-button-warning',
        accept: () => { }
      });
      return;
    }

    // Si manejarBancos está activo, mostrar dialog de selección de cuenta antes de confirmar
    // En un re-cierre (período ya fue cerrado antes) el dialog no es necesario:
    // los movimientos editados ya actualizaron saldosCuentas, y el CF aplica solo el delta de B.2
    const esRecierre = !!(this.openPeriodoData?.closedAt || this.openPeriodoData?.closedByUid);
    if (this.manejarBancos && !esRecierre) {
      this.showCierreDialog = true;
      return;
    }

    this.confirmationService.confirm({
      message: this.translate.instant('REPORTS.CONFIRM_CLOSE_MSG', { month: this.previousMonthName }),
      header: this.translate.instant('REPORTS.CONFIRM_CLOSE_HEADER'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translate.instant('REPORTS.CONFIRM_CLOSE_ACCEPT'),
      rejectLabel: this.translate.instant('COMMON.CANCEL'),
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary',
      accept: async () => {
        this.cerrarInforme();
      }
    });
  }

  private logPreInformeDebug(source: string, pre: PreInformeDoc | null) {
  }

  /** Total de egresos B.2 (excluye filas de subtotal/total/DP) */
  calcularTotalEgresosB2(): number {
    const SKIP = new Set(['EG-B2-SUB', 'EG-B2-TOTAL', 'EG-B2-DP']);
    return this.informeFinancieroEgresosB2Options
      .filter(r => r.codigo && !SKIP.has(r.codigo))
      .reduce((sum, r) => sum + (Number(r.valor) || 0), 0);
  }

  /** Listado de cuentas activas para el selector del dialog de cierre */
  get cuentasActivasCierre(): CuentaBancaria[] {
    return this.cuentasBancarias.filter(c => c.activo);
  }

  /** Confirmar cierre desde el dialog de selección de cuenta (manejarBancos activo) */
  async confirmarCierreConCuenta(): Promise<void> {
    this.showCierreDialog = false;
    await this.cerrarInforme();
  }

  private llenarDesdeDoc(pre: PreInformeDoc | null) {
    let items = pre?.items ?? [];

    // FALLBACK: Si items está vacío pero existe itemsMap, reconstruir items desde el mapa
    if (items.length === 0 && pre?.itemsMap) {
      items = Object.entries(pre.itemsMap).map(([key, value]) => ({
        item: key,
        ...value
      }));
    }

    const byCode = new Map(items.filter(i => i.codigo).map(i => [this.norm(i.codigo!), i]));
    const byDesc = new Map(items.map(i => [this.norm(i.descripcion), i]));

    const BLOQUES_CALCULADOS_B2 = new Set(['EG-B2-01', 'EG-B2-02', 'EG-B2-SUB', 'EG-B2-TOTAL']);

    this.observaciones = pre?.observaciones || '';

    // EG-B2
    this.informeFinancieroEgresosB2Options = this.informeFinancieroEgresosB2Options.map(opt => {
      if (opt.codigo && BLOQUES_CALCULADOS_B2.has(opt.codigo)) return opt; // ← no sobrescribir
      const hit = (opt.codigo && byCode.get(this.norm(opt.codigo))) || byDesc.get(this.norm(opt.descripcion));
      const v = hit?.valor;

      let finalVal = Number(v ?? 0);
      // Forzar pago sistema informe a 5 si es 0
      if (opt.codigo === 'EG-B2-13' && finalVal === 0) {
        finalVal = 5;
      }

      const fixedVal = opt.esLecturaSolo ? Number(opt.valor ?? 0) : undefined;
      if (typeof fixedVal === 'number' && fixedVal > 0) {
        finalVal = fixedVal;
      }

      return { ...opt, valor: finalVal };
    });

    // Obrero
    this.informeObreoOptions = this.informeObreoOptions.map(opt => {
      const hit = (opt.codigo && byCode.get(this.norm(opt.codigo))) || byDesc.get(this.norm(opt.descripcion));
      return { ...opt, valor: hit?.valor ?? '' };
    });

    // Espiritual
    this.informeEspiritualOptions = this.informeEspiritualOptions.map(opt => {
      const hit = (opt.codigo && byCode.get(this.norm(opt.codigo))) || byDesc.get(this.norm(opt.descripcion));
      const v = hit?.valor;
      return { ...opt, valor: Number(v ?? 0) };
    });
  }

  private norm(s: string) {
    return (s ?? '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
  }

  private mesInformeYM() {
    const { currYM, prevYM } = this.firestoreService.getCurrentAndPreviousYM();
    this.currYM = currYM;
    this.prevYM = prevYM;
    this.informeYM = this.funciones.formatYMtoText(this.prevYM);
    this.mesAno = this.informeYM;
  }

  private calcularInformeFinanciero() {
    const { totalIngresoGeneralIglesia, ofrendaMisionera, subTotal, saldoEnCajaMesAnterior } = this.seccionIngresos();
    const totalEgresosB1 = this.seccionEgresosB1();

    const dataNacional = {
      subTotalING: subTotal,
      ofrendaMisionera: ofrendaMisionera
    }

    const totalEgresosB2 = this.seccionEgresosB2(dataNacional);

    const payloadBalance = { totalIngresoGeneralIglesia, totalEgresosB1, totalEgresosB2, saldoEnCajaMesAnterior };
    this.seccionBalance(payloadBalance);

    this.cdr.detectChanges();
  }

  private informeEspiritual() {
    const miembrosBautizados = this.members.filter(m => m.bautismo).length;
  }

  // -- SECCIONES DEL INFORME FINANCIERO -- //

  private seccionIngresos(): { totalIngresoGeneralIglesia: number, ofrendaMisionera: number, subTotal: number, saldoEnCajaMesAnterior: number } {
    const ingresos = (this.finanzas || []).filter(f => f.tipoMovimiento === 'Ingreso');
    const sum = (codigoOrCodes: string | string[]) => {
      const codes = Array.isArray(codigoOrCodes) ? codigoOrCodes : [codigoOrCodes];
      return ingresos
        .filter(f => codes.includes(String(f.codigo)))
        .reduce((s, x) => s + (Number(x.monto) || 0), 0);
    };

    //INGRESOS
    const diezmoIglesia = sum('ING-01');
    const ofrendasDiarias = sum('ING-02');
    const ofrendasEscuelaDominical = sum('ING-03');
    const ofrendasProgramaRadial = sum('ING-04');
    const ofrendaMisionera = sum('ING-05');
    const ofrendaPredicador = sum('ING-06');
    const ofrendaEspecialProTemplo = sum('ING-07');
    const ayudaFondoNacionalInternac = sum('ING-08');
    const saldoEnCajaMesAnterior = sum(['ING-SI', 'ING-SAL-ANT']);

    const subTotal = diezmoIglesia + ofrendasDiarias + ofrendasEscuelaDominical;
    const totalIngresoGeneralIglesia = subTotal + ofrendasProgramaRadial + ofrendaMisionera + ofrendaPredicador + ofrendaEspecialProTemplo + ayudaFondoNacionalInternac;

    // ACTUALIZA FILAS
    this.actualizarFilas('ING-01', diezmoIglesia);
    this.actualizarFilas('ING-02', ofrendasDiarias);
    this.actualizarFilas('ING-03', ofrendasEscuelaDominical);
    this.actualizarFilas('ING-SUB', subTotal);
    this.actualizarFilas('ING-04', ofrendasProgramaRadial);
    this.actualizarFilas('ING-05', ofrendaMisionera);
    this.actualizarFilas('ING-06', ofrendaPredicador);
    this.actualizarFilas('ING-07', ofrendaEspecialProTemplo);
    this.actualizarFilas('ING-08', ayudaFondoNacionalInternac);
    this.actualizarFilas('ING-TOTAL', totalIngresoGeneralIglesia);

    return { totalIngresoGeneralIglesia, ofrendaMisionera, subTotal, saldoEnCajaMesAnterior };
  }

  private seccionEgresosB1(): number {
    // EGRESOS
    const egresos = (this.finanzas || []).filter(f => f.tipoMovimiento === 'Egreso');
    const sumEgresos = (codigo: string) =>
      egresos.filter(f => f.codigo === codigo).reduce((s, x) => s + (Number(x.monto) || 0), 0);

    let totalEgresosB1 = 0;

    // EGRESOS B1 DINÁMICO
    // Iteramos sobre todos los ítems de B1 que NO sean el Sub-Total
    this.informeFinancieroEgresosB1Options.forEach(opcion => {
      if (opcion.codigo === 'EG-B1-SUB') return;

      const monto = sumEgresos(opcion.codigo!);
      this.actualizarEgresosB1(opcion.codigo!, monto);
      totalEgresosB1 += monto;
    });

    this.actualizarEgresosB1('EG-B1-SUB', totalEgresosB1);

    return totalEgresosB1;
  }

  private seccionEgresosB2(data: { subTotalING: number; ofrendaMisionera: number }): number {
    // 1) Calculados
    const diezmoDeDiezmos = Number(data?.subTotalING ?? 0) * 0.1;
    const ofrendaMisionera = Number(data?.ofrendaMisionera ?? 0);
    const bethelTV = Number(diezmoDeDiezmos ?? 0) * 0.03;

    // 2) Asigna primero los calculados
    this.actualizarEgresoNacional('EG-B2-01', diezmoDeDiezmos);
    this.actualizarEgresoNacional('EG-B2-02', ofrendaMisionera);
    this.actualizarEgresoNacional('EG-B2-14', bethelTV);

    // 3) Ahora calculamos los egesos B2 reales dinámicos (excepto los calculados lógicamente o protegidos)
    const egresos = (this.finanzas || []).filter(f => f.tipoMovimiento === 'Egreso');
    const sumEgresos = (codigo: string) =>
      egresos.filter(f => f.codigo === codigo).reduce((s, x) => s + (Number(x.monto) || 0), 0);

    let totalEgresosB2Calculado = 0;

    this.informeFinancieroEgresosB2Options.forEach(opcion => {
      // Ignoramos los totales/subtotales
      if (['EG-B2-DP', 'EG-B2-SUB', 'EG-B2-TOTAL'].includes(opcion.codigo!)) return;

      let monto: number;
      const fixedVal = opcion.esLecturaSolo ? Number(opcion.valor ?? 0) : 0;
      // Los códigos B2-01, B2-02 y B2-14 ya están pre-calculados por la función (son protegidos matemáticamente)
      if (['EG-B2-01', 'EG-B2-02', 'EG-B2-14'].includes(opcion.codigo!)) {
        monto = opcion.valor as number;
      } else if (fixedVal > 0) {
        // Respetar valores fijos provenientes de Settings/finanzas
        monto = fixedVal;
        this.actualizarEgresoNacional(opcion.codigo!, monto);
      } else {
        const calculado = sumEgresos(opcion.codigo!);
        const manual = Number(opcion.valor ?? 0);
        // PRIORIDAD: preInforme manual > movimientos calculados
        monto = manual > 0 ? manual : calculado;

        this.actualizarEgresoNacional(opcion.codigo!, monto);
      }
      totalEgresosB2Calculado += (monto || 0);
    });

    this.actualizarEgresoNacional('EG-B2-SUB', totalEgresosB2Calculado);

    // 4) TOTAL = SUB + Diezmos del pastor
    const diezmosDelPastor = Number(
      this.informeFinancieroEgresosB2Options.find(f => f.codigo === 'EG-B2-DP')?.valor
    ) || 0;

    const totalEnviadoFondoNacional = totalEgresosB2Calculado + diezmosDelPastor;
    this.actualizarEgresoNacional('EG-B2-TOTAL', totalEnviadoFondoNacional);

    return totalEgresosB2Calculado;
  }

  private seccionBalance(data: any) {
    this.actualizarBalanceDelMes('BAL-ING-TOT', data.totalIngresoGeneralIglesia);
    this.actualizarBalanceDelMes('BAL-EGR-TOT', data.totalEgresosB1 + data.totalEgresosB2);

    const saldoEnCajaMes = (data.totalIngresoGeneralIglesia || 0) - (data.totalEgresosB1 + data.totalEgresosB2 || 0);
    this.actualizarBalanceDelMes('BAL-SAL-MES', saldoEnCajaMes);

    // Saldo en caja mes anterior
    this.actualizarBalanceDelMes('BAL-SAL-ANT', data.saldoEnCajaMesAnterior);

    // Redondear a 2 decimales para evitar errores de punto flotante (ej: -0.000000001)
    const saldoFinalDelMes = Math.round((saldoEnCajaMes + (data.saldoEnCajaMesAnterior || 0)) * 100) / 100;
    this.actualizarBalanceDelMes('BAL-FINAL', saldoFinalDelMes);
  }

  // -- ACTUALIZAR FILAS -- //

  private actualizarFilas(codigo: string, nuevoValor?: number) {
    const fila = this.informeFinancieroIngresosOptions
      ?.find(f => f.codigo === codigo);

    if (fila) {
      fila.valor = nuevoValor !== undefined ? nuevoValor : Number(nuevoValor) || 0;
      this.informeFinancieroIngresosOptions = [...this.informeFinancieroIngresosOptions];
      this.cdr.markForCheck();
    }
  }

  private actualizarEgresosB1(filaCodigo: string, nuevoValor?: number) {
    const fila = this.informeFinancieroEgresosB1Options
      ?.find(f => f.codigo === filaCodigo);

    if (fila) {
      fila.valor = nuevoValor !== undefined ? nuevoValor : Number(nuevoValor) || 0;
      this.informeFinancieroEgresosB1Options = [...this.informeFinancieroEgresosB1Options];
      this.cdr.markForCheck();
    }
  }

  private actualizarBalanceDelMes(codigo: string, nuevoValor?: number) {
    const fila = this.informeFinancieroBalanceOptions
      ?.find(f => f.codigo === codigo);

    if (fila) {
      fila.valor = nuevoValor !== undefined ? nuevoValor : Number(nuevoValor) || 0;
      this.informeFinancieroBalanceOptions = [...this.informeFinancieroBalanceOptions];
      this.cdr.markForCheck();
    }
  }

  private actualizarEgresoNacional(codigo: string, nuevoValor: number) {
    const fila = this.informeFinancieroEgresosB2Options
      ?.find(f => f.codigo === codigo);

    if (fila) {
      fila.valor = nuevoValor !== undefined ? nuevoValor : Number(nuevoValor) || 0;
      this.informeFinancieroEgresosB2Options = [...this.informeFinancieroEgresosB2Options];
      this.cdr.markForCheck();
    }
  }

  async exportarPDF() {
    if (this.loadingPdf) {
      return;
    }

    this.isExporting = true;
    this.loadingPdf = true;
    this.spinnerService.show();

    try {
      const uiLang = this.languageService.getCurrentLang() === 'it' ? 'it' : 'es';
      const payload = this.buildInformeMensualPdfPayload(uiLang);
      const functions = getFunctions();
      const generarPdfCallable = httpsCallable<InformeMensualPdfPayload, InformeMensualPdfResponse>(functions, 'generarInformeMensualPdf');
      const response = await generarPdfCallable(payload);
      const data = response?.data;

      if (!data?.base64) {
        throw new Error(this.translate.instant('REPORTS.PDF_ERR_NO_BASE64'));
      }

      const contentType = data.contentType ?? 'application/pdf';
      const fileName = data.fileName ?? `informe-${this.mesAno || this.previousMonthName || 'mes'}.pdf`;
      this.triggerPdfDownload(data.base64, contentType, fileName);
      this.toastService.showSuccess(this.translate.instant('REPORTS.TOAST_PDF_OK'));
    } catch (error: any) {
      this.toastService.showError(error?.message || this.translate.instant('REPORTS.TOAST_PDF_ERR'));
    } finally {
      this.loadingPdf = false;
      this.spinnerService.hide();
      this.isExporting = false;
    }
  }

  private buildInformeMensualPdfPayload(uiLang: 'es' | 'it'): InformeMensualPdfPayload {
    const locale = uiLang === 'it' ? 'it-IT' : 'es-ES';
    const fechaInforme = new Date().toLocaleDateString(locale, {
      day: '2-digit', month: 'long', year: 'numeric'
    });
    const observaciones = (this.observaciones ?? '').trim();

    const mappedObrero = this.mapObreroItems(this.informeObreoOptions, uiLang);

    return {
      uiLang,
      moneda: this.missionCurrency.getCurrencyCode(),
      iglesiaName: this.iglesiaName || this.iglesiaData?.churchName || '',
      zonaNombre: this.getZonaNombre(),
      previousMonthName: this.getPeriodoDisplayForPdf(uiLang),
      fechaInforme,
      pastorName: this.pastorName || this.iglesiaData?.pastorName || '',
      observaciones,
      imageFirmaUrl: this.imageFirmaUrl || undefined,
      informeEspiritualOptions: this.mapEspiritualItems(this.informeEspiritualOptions, uiLang),
      informeFinancieroIngresosOptions: this.mapFinancieroItems(this.informeFinancieroIngresosOptions, uiLang),
      informeFinancieroEgresosB1Options: this.mapFinancieroItems(this.informeFinancieroEgresosB1Options, uiLang),
      informeFinancieroEgresosB2Options: this.mapFinancieroItems(this.informeFinancieroEgresosB2Options, uiLang),
      informeFinancieroBalanceOptions: this.mapFinancieroItems(this.informeFinancieroBalanceOptions, uiLang),
      informeObreoOptions: mappedObrero,
    };
  }

  private mapFinancieroItems(list: Informes[] = [], uiLang: 'es' | 'it' = 'es'): InformeItemBasePayload[] {
    return (list ?? []).map(row => ({
      item: row.item,
      descripcion: uiLang === 'it'
        ? this.getInformeLabel(row.codigo, row.descripcion ?? '')
        : row.descripcion,
      valor: this.toNumber(row.valor),
    }));
  }

  private mapEspiritualItems(list: Informes[] = [], uiLang: 'es' | 'it' = 'es'): InformeItemBasePayload[] {
    return (list ?? []).map(row => {
      const valor = this.toNumber(row.valor);
      const es = row.descripcion ?? '';
      return {
        item: row.item,
        descripcion: uiLang === 'it' ? this.getInformeLabel(row.codigo, es) : es,
        valor,
        cumplido: valor > 0,
      } as InformeItemBasePayload;
    });
  }

  private mapObreroItems(list: Informes[] = [], uiLang: 'es' | 'it' = 'es'): InformeItemBasePayload[] {
    return (list ?? []).map(row => {
      const affirmative = this.isObreroAffirmative(row.valor);
      const es = row.descripcion ?? '';

      return {
        item: row.item,
        descripcion: uiLang === 'it' ? this.getInformeLabel(row.codigo, es) : es,
        resp: affirmative
          ? this.translate.instant('REPORTS.OBRERO_TAG_YES')
          : this.translate.instant('REPORTS.OBRERO_TAG_NO'),
        cumplido: affirmative,
      };
    });
  }

  private getPeriodoDisplayForPdf(uiLang: 'es' | 'it'): string {
    const ym = (this.periodo || this.prevYM || '').trim();
    if (!ym || !/^\d{4}-\d{2}$/.test(ym)) {
      return this.previousMonthName || this.mesAno || '';
    }
    const [y, m] = ym.split('-').map(Number);
    const d = new Date(y, (m - 1), 1);
    const locale = uiLang === 'it' ? 'it-IT' : 'es-ES';
    return d.toLocaleDateString(locale, { month: 'long', year: 'numeric' });
  }

  /**
   * Fallback IT cuando aún no hay entrada en Settings/i18nItems (misma lista que PDF previo).
   */
  private translateStaticInformeLabelIt(esLabel: string): string {
    const key = String(esLabel ?? '').trim();
    if (!key) return esLabel;

    const map: Record<string, string> = {
      // Informe espiritual (fijos)
      'Miembros bautizados activos': 'Membri battezzati attivi',
      'Creyentes bautizados no reconocidos': 'Credenti battezzati non riconosciuti',
      'Nuevos creyentes': 'Nuovi credenti',
      'Miembros bautizados en Espíritu Santo': 'Membri battezzati nello Spirito Santo',
      'Profesiones de fe durante el mes': 'Professioni di fede durante il mese',
      'Promedio asistencia Escuela Dominical': 'Media presenza alla Scuola Domenicale',
      // Informe obrero (fijos)
      'Efectuó culto misionero': 'Ha tenuto culto missionario',
      'Efectuó culto Santa Cena': 'Ha tenuto culto Santa Cena',
      'Asistió a culto confraternidad': 'Ha partecipato al culto di confraternita',
      'Recibió visita del presbítero': 'Ha ricevuto visita del presbitero',
      'Efectuó visitas': 'Ha effettuato visite',
      'Realizó evangelismo': 'Ha svolto evangelizzazione',
      'Ha fundado campos blancos': 'Ha fondato campi bianchi',
      'Ha formado obreros': 'Ha formato operai',
      'Efectúa ayuda social': 'Esegue aiuto sociale',
      'Efectuó ayuno': 'Ha osservato digiuno',
    };

    return map[key] || esLabel;
  }

  /**
   * Interpreta el valor del informe obrero según la convención de Firestore:
   * - "0" (string) = SI (afirmativo)
   * - "" (string vacío) = NO (negativo)
   * - También soporta boolean y number para compatibilidad
   */
  isObreroAffirmative(valor: any): boolean {
    // Handle different types:
    if (typeof valor === 'boolean') {
      return valor;
    } else if (typeof valor === 'number') {
      return valor === 0; // number 0 means YES
    } else {
      // String handling
      const rawValue = String(valor ?? '').trim();

      // Firestore convention: "0" = YES, "" or empty = NO
      if (rawValue === '0') {
        return true;
      }

      if (rawValue === '') {
        return false;
      }

      // Also support other formats for flexibility
      const normalized = rawValue
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

      return normalized === 'si' || normalized === 'true' || normalized === '1';
    }
  } private toNumber(value: number | string): number {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : 0;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private triggerPdfDownload(base64: string, contentType: string, fileName: string) {
    if (typeof window === 'undefined') {
      return;
    }

    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([new Uint8Array(byteNumbers)], { type: contentType });
    const url = URL.createObjectURL(blob);

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
    URL.revokeObjectURL(url);
  }

  private getZonaNombre(): string {
    const data = this.iglesiaData as Record<string, any> | null;
    return data?.['zonaNombre'] || data?.['zoneName'] || data?.['zona'] || this.translate.instant('REPORTS.ZONE_UNSPECIFIED');
  }

  async storageFileToDataUrl(path: string): Promise<string> {
    const storage = getStorage();
    const r = ref(storage, path);          // p.ej. 'firmas/uid.png'
    const bytes = await getBytes(r);       // obtiene ArrayBuffer
    const bin = Array.from(new Uint8Array(bytes)).map(b => String.fromCharCode(b)).join('');
    const base64 = btoa(bin);
    return `data:image/png;base64,${base64}`;
  }

  /** Convierte una URL de imagen a base64 */
  async urlToBase64(url: string | null): Promise<string | null> {
    if (!url) return null;
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      return null;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  atras() {
    this.router.navigate(['/dashboard/reports']);
  }

}
